@if (loading) {
  <div class="certificate-overview__loading">
    <mat-spinner diameter="48"></mat-spinner>
  </div>
}

@if (!loading && dataSource.data.length === 0) {
  <mat-card appearance="outlined" class="certificate-overview__no-data">
    <mat-card-content>{{
      'certificateOverview.noData' | translate
    }}</mat-card-content>
  </mat-card>
}

@if (!loading && dataSource.data.length > 0) {
  <div class="certificate-overview__toolbar">
    <mat-form-field appearance="outline" class="certificate-overview__search">
      <mat-label>{{ 'certificateOverview.search' | translate }}</mat-label>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (ngModelChange)="applyFilter()"
      />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <div
      class="certificate-overview__company-chips"
      role="group"
      [attr.aria-label]="'certificateOverview.companyFilter' | translate"
    >
      <button
        type="button"
        class="certificate-overview__fchip"
        [ngClass]="{
          'certificate-overview__fchip--on': selectedCompany === 'ALL',
        }"
        [attr.aria-pressed]="selectedCompany === 'ALL'"
        (click)="onCompanyFilterChange('ALL')"
      >
        {{ 'certificateOverview.allCompanies' | translate }}
      </button>
      @for (company of companies(); track company.id) {
        <button
          type="button"
          class="certificate-overview__fchip"
          [style]="
            chipStyle(company.color, selectedCompany === company.abbreviation)
          "
          [attr.aria-pressed]="selectedCompany === company.abbreviation"
          [matTooltip]="company.name"
          (click)="onCompanyFilterChange(company.abbreviation)"
        >
          {{ company.abbreviation }}
        </button>
      }
      <button
        type="button"
        class="certificate-overview__fchip"
        [ngClass]="{ 'certificate-overview__fchip--on-bewerber': applicantOnly }"
        [attr.aria-pressed]="applicantOnly"
        [attr.aria-label]="'certificateOverview.applicantFilter' | translate"
        (click)="onApplicantFilterToggle()"
      >
        {{ 'certificateOverview.applicants' | translate }}
      </button>
      <button
        type="button"
        class="certificate-overview__fchip"
        [ngClass]="{ 'certificate-overview__fchip--on-freelancer': freelancerOnly }"
        [attr.aria-pressed]="freelancerOnly"
        [attr.aria-label]="'certificateOverview.freelancerFilter' | translate"
        (click)="onFreelancerFilterToggle()"
      >
        {{ 'certificateOverview.freelancers' | translate }}
      </button>
    </div>

    <div class="certificate-overview__tpl-dd">
      <button
        class="certificate-overview__tpl-btn"
        [class.open]="templateDropdownOpen"
        (click)="toggleTemplateDropdown($event)"
      >
        <mat-icon class="certificate-overview__tpl-icon">view_column</mat-icon>
        <span class="certificate-overview__tpl-cur">{{
          getActiveTemplateName()
        }}</span>
        <mat-icon class="certificate-overview__tpl-chevron"
          >expand_more</mat-icon
        >
      </button>
    </div>
  </div>

  <div class="certificate-overview__legend">
    <span
      class="certificate-overview__legend-item certificate-overview__legend-item--certified"
    >
      <span class="certificate-overview__legend-dot"
        ><mat-icon>check_circle</mat-icon></span
      >
      <span class="certificate-overview__legend-label">{{
        'certificateOverview.legend.certified' | translate
      }}</span>
    </span>
    <span
      class="certificate-overview__legend-item certificate-overview__legend-item--exam_planned"
    >
      <span class="certificate-overview__legend-dot"
        ><mat-icon>event</mat-icon></span
      >
      <span class="certificate-overview__legend-label">{{
        'certificateOverview.legend.exam_planned' | translate
      }}</span>
    </span>
    <span
      class="certificate-overview__legend-item certificate-overview__legend-item--training_done"
    >
      <span class="certificate-overview__legend-dot"
        ><mat-icon>school</mat-icon></span
      >
      <span class="certificate-overview__legend-label">{{
        'certificateOverview.legend.training_done' | translate
      }}</span>
    </span>
    <span
      class="certificate-overview__legend-item certificate-overview__legend-item--training_planned"
    >
      <span class="certificate-overview__legend-dot"
        ><mat-icon>schedule</mat-icon></span
      >
      <span class="certificate-overview__legend-label">{{
        'certificateOverview.legend.training_planned' | translate
      }}</span>
    </span>
  </div>

  @if (templateDropdownOpen) {
    <div
      class="certificate-overview__tpl-menu"
      [style.top.px]="tplMenuTopPx"
      [style.left.px]="tplMenuLeftPx"
      (click)="$event.stopPropagation()"
    >
      <div class="certificate-overview__tpl-menu-lbl">
        {{ 'certificateOverview.templates.vorlage' | translate }}
      </div>
      @for (t of PREDEFINED_TEMPLATES; track t.id) {
        <button
          class="certificate-overview__tpl-item"
          [class.active]="activeTemplateId === t.id"
          (click)="applyTemplateById(t.id); templateDropdownOpen = false"
        >
          <span class="certificate-overview__tpl-check">
            @if (activeTemplateId === t.id) {
              <mat-icon>check</mat-icon>
            }
          </span>
          <span class="certificate-overview__tpl-name">{{
            t.nameKey | translate
          }}</span>
          <span class="certificate-overview__tpl-meta">{{
            t.certs.length
          }}</span>
        </button>
      }
      @if (userTemplates.length > 0) {
        <div class="certificate-overview__tpl-menu-lbl">
          {{ 'certificateOverview.templates.eigenVorlagen' | translate }}
        </div>
        @for (t of userTemplates; track t.id) {
          <button
            class="certificate-overview__tpl-item"
            [class.active]="activeTemplateId === t.id"
            (click)="applyTemplateById(t.id); templateDropdownOpen = false"
          >
            <span class="certificate-overview__tpl-check">
              @if (activeTemplateId === t.id) {
                <mat-icon>check</mat-icon>
              }
            </span>
            <span class="certificate-overview__tpl-name">{{ t.name }}</span>
            <span class="certificate-overview__tpl-meta">{{
              t.certs.length
            }}</span>
            <span
              class="certificate-overview__tpl-del"
              (click)="
                $event.stopPropagation(); confirmDeleteTemplate(t.id, t.name)
              "
            >
              <mat-icon>close</mat-icon>
            </span>
          </button>
        }
      }
      <div class="certificate-overview__tpl-sep"></div>
      <button
        class="certificate-overview__tpl-item certificate-overview__tpl-action"
        [class.active]="activeTemplateId === 'custom'"
        (click)="templateDropdownOpen = false; openTemplatePicker()"
      >
        <span class="certificate-overview__tpl-check">
          @if (activeTemplateId === 'custom') {
            <mat-icon>check</mat-icon>
          } @else {
            <mat-icon>edit</mat-icon>
          }
        </span>
        <span class="certificate-overview__tpl-name"
          >{{ 'certificateOverview.templates.custom' | translate }}…</span
        >
      </button>
    </div>
  }

  <div class="certificate-overview__table-wrapper">
    <div class="certificate-overview__table-scroll">
      <mat-table
        [dataSource]="dataSource"
        [style.minWidth]="tableMinWidth"
        matSort
        matSortActive="consultantName"
        matSortDirection="asc"
        multiTemplateDataRows
      >
        <ng-container matColumnDef="consultantName" sticky>
          <mat-header-cell *matHeaderCellDef mat-sort-header>{{
            'certificateOverview.consultantName' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-icon
              class="certificate-overview__expand-chevron"
              [class.certificate-overview__expand-chevron--open]="
                isExpanded(row)
              "
              >chevron_right</mat-icon
            >
            {{ row.consultantName }}
          </mat-cell>
        </ng-container>

        @for (cert of CERTIFICATE_COLUMNS; track cert.key) {
          <ng-container [matColumnDef]="cert.key">
            <mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [matTooltip]="cert.fullName"
              class="certificate-overview__cert-header"
            >
              {{ cert.label }}
            </mat-header-cell>
            <mat-cell
              *matCellDef="let row"
              class="certificate-overview__cert-cell"
              (mouseenter)="onCellMouseEnter($event, row, cert.key)"
              (mousemove)="onCellMouseMove($event)"
              (mouseleave)="onCellMouseLeave()"
            >
              @if (getMilestone(row, cert.key); as milestone) {
                @if (milestone.status !== 'none') {
                  <div
                    [class]="
                      'certificate-overview__cert-chip certificate-overview__cert-chip--' +
                      milestone.status
                    "
                  >
                    <mat-icon class="certificate-overview__cert-chip__icon">{{
                      MILESTONE_ICONS[milestone.status]
                    }}</mat-icon>
                  </div>
                }
              }
            </mat-cell>
          </ng-container>
        }

        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell *matHeaderCellDef>{{
            'certificateOverview.mailColumn' | translate
          }}</mat-header-cell>
          <mat-cell *matCellDef="let row">
            @if (isAdminOrOffice) {
              <button
                mat-icon-button
                [matTooltip]="'certificateOverview.editMilestones' | translate"
                (click)="openEditModal(row)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            }
            <button
              mat-icon-button
              [matTooltip]="'certificateOverview.goToProfile' | translate"
              [routerLink]="['/profile', row.consultantId]"
            >
              <mat-icon>person</mat-icon>
            </button>
            <button
              mat-icon-button
              [matTooltip]="'certificateOverview.sendMail' | translate"
              (click)="openMailModal(row)"
            >
              <mat-icon>mail</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <mat-cell
            *matCellDef="let row"
            class="certificate-overview__expand-detail-cell"
          >
            @if (isExpanded(row)) {
              @let activeCerts = getActiveCertsForRow(row);
              @if (activeCerts.length > 0) {
                <div class="certificate-overview__expand-detail">
                  @for (item of activeCerts; track item.col.key) {
                    <div
                      [class]="
                        'certificate-overview__detail-card certificate-overview__detail-card--' +
                        item.milestone.status
                      "
                    >
                      <div class="certificate-overview__detail-card__header">
                        <span class="certificate-overview__detail-card__chip">
                          <mat-icon>{{
                            MILESTONE_ICONS[item.milestone.status]
                          }}</mat-icon>
                        </span>
                        <span
                          class="certificate-overview__detail-card__cert-name"
                          >{{ item.col.fullName }}</span
                        >
                      </div>
                      <div class="certificate-overview__detail-card__fields">
                        @for (
                          field of milestoneFields(item.milestone);
                          track $index
                        ) {
                          <div class="certificate-overview__detail-card__field">
                            <mat-icon
                              class="certificate-overview__detail-card__field-icon"
                              >{{ field.icon }}</mat-icon
                            >
                            <span
                              class="certificate-overview__detail-card__field-label"
                              >{{ field.labelKey | translate }}</span
                            >
                            <span
                              class="certificate-overview__detail-card__field-value"
                              >{{ field.value }}</span
                            >
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="certificate-overview__expand-detail-empty">
                  {{ 'certificateOverview.displayMode.noCerts' | translate }}
                </div>
              }
            }
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="certificate-overview__row--expandable"
          [class.certificate-overview__row--expanded]="isExpanded(row)"
          (click)="toggleExpand(row)"
        >
        </mat-row>
        <mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="certificate-overview__detail-row"
          [style.minWidth]="detailRowMinWidth"
          [style.display]="isExpanded(row) ? 'flex' : 'none'"
        >
        </mat-row>
      </mat-table>
    </div>
    @if (dataSource.filteredData.length === 0) {
      <p class="certificate-overview__no-results" role="status">
        {{ 'certificateOverview.noData' | translate }}
      </p>
    }
  </div>

  @if (tooltipData) {
    @let ftFields = milestoneFields(tooltipData.milestone);
    <div
      class="certificate-overview__floating-tooltip"
      [style.left.px]="tooltipData.x + 14"
      [style.top.px]="tooltipData.y + 14"
    >
      <div class="certificate-overview__ft-header">
        <span
          [class]="
            'certificate-overview__ft-chip certificate-overview__ft-chip--' +
            tooltipData.milestone.status
          "
        >
          <mat-icon>{{
            MILESTONE_ICONS[tooltipData.milestone.status]
          }}</mat-icon>
        </span>
        <div class="certificate-overview__ft-title">
          <span class="certificate-overview__ft-cert-name">{{
            tooltipData.cert.fullName
          }}</span>
          <span class="certificate-overview__ft-status">{{
            'certificateOverview.milestoneStatus.' +
              tooltipData.milestone.status | translate
          }}</span>
        </div>
      </div>
      @if (ftFields.length > 0) {
        <div class="certificate-overview__ft-fields">
          @for (field of ftFields; track $index) {
            <div class="certificate-overview__ft-field">
              <mat-icon class="certificate-overview__ft-field-icon">{{
                field.icon
              }}</mat-icon>
              <span class="certificate-overview__ft-field-label">{{
                field.labelKey | translate
              }}</span>
              <span class="certificate-overview__ft-field-value">{{
                field.value
              }}</span>
            </div>
          }
        </div>
      }
    </div>
  }
}

<app-modal
  class="certificate-overview__mail-modal"
  [title]="'certificateOverview.mailModal.title' | translate"
  [(visible)]="mailModalVisible"
  [showButtons]="true"
  [showClose]="true"
  [saveText]="'certificateOverview.mailModal.send'"
  [disabled]="selectedCertificates.length === 0 || sending"
  [contentTemplate]="mailModalContent"
  (save)="sendReminder()"
></app-modal>

<ng-template #mailModalContent>
  <div class="certificate-overview__modal-content">
    <p class="certificate-overview__modal-consultant">
      {{ selectedConsultant?.consultantName }}
    </p>

    <mat-form-field
      appearance="outline"
      class="certificate-overview__modal-field"
    >
      <mat-label>{{
        'certificateOverview.mailModal.certificates' | translate
      }}</mat-label>
      <mat-select
        [(ngModel)]="selectedCertificates"
        [multiple]="true"
        (ngModelChange)="onCertificatesChange()"
      >
        @for (cert of CERTIFICATE_COLUMNS; track cert.key) {
          <mat-option [value]="cert.fullName">{{ cert.label }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-radio-group
      [(ngModel)]="reminderType"
      (ngModelChange)="onTypeChange()"
      class="certificate-overview__modal-radio"
    >
      <mat-radio-button value="reminder">{{
        'certificateOverview.mailModal.typeReminder' | translate
      }}</mat-radio-button>
      <mat-radio-button value="newCertification">{{
        'certificateOverview.mailModal.typeNew' | translate
      }}</mat-radio-button>
    </mat-radio-group>

    <mat-form-field
      appearance="outline"
      class="certificate-overview__modal-field"
    >
      <mat-label>{{
        'certificateOverview.mailModal.message' | translate
      }}</mat-label>
      <textarea matInput [(ngModel)]="mailText" rows="4"></textarea>
    </mat-form-field>
  </div>
</ng-template>

@if (editModalVisible) {
  <div
    class="certificate-overview__edit-backdrop"
    (click)="editModalVisible = false"
  ></div>
  <div
    class="certificate-overview__edit-card"
    (click)="$event.stopPropagation()"
  >
    <div class="certificate-overview__modal-head">
      <div>
        <div class="certificate-overview__modal-sub">
          {{ 'certificateOverview.milestoneEditor.title' | translate }}
        </div>
        <div class="certificate-overview__modal-title">
          {{ editConsultant?.consultantName }}
        </div>
      </div>
      <button
        class="certificate-overview__modal-x"
        type="button"
        (click)="editModalVisible = false"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div class="certificate-overview__modal-body">
      <p class="certificate-overview__edit-intro">
        {{ 'certificateOverview.milestoneEditor.intro' | translate }}
      </p>
      <div class="certificate-overview__edit-grid-head">
        <span>{{
          'certificateOverview.milestoneEditor.cert' | translate
        }}</span>
        <span
          ><mat-icon>schedule</mat-icon
          >{{
            'certificateOverview.milestoneEditor.trainingPlanned' | translate
          }}</span
        >
        <span
          ><mat-icon>school</mat-icon
          >{{
            'certificateOverview.milestoneEditor.trainingDate' | translate
          }}</span
        >
        <span
          ><mat-icon>event</mat-icon
          >{{
            'certificateOverview.milestoneEditor.examDate' | translate
          }}</span
        >
        <span
          ><mat-icon>check_circle</mat-icon
          >{{
            'certificateOverview.milestoneEditor.certifiedDate' | translate
          }}</span
        >
      </div>
      @for (col of CERTIFICATE_COLUMNS; track col.key) {
        <div
          class="certificate-overview__edit-row"
          [class.is-none]="deriveStatus(editMilestones[col.key]) === 'none'"
        >
          <div class="certificate-overview__er-cert">
            <span
              [class]="
                'certificate-overview__er-dot certificate-overview__er-dot--' +
                deriveStatus(editMilestones[col.key])
              "
            >
              @if (MILESTONE_ICONS[deriveStatus(editMilestones[col.key])]) {
                <mat-icon>{{
                  MILESTONE_ICONS[deriveStatus(editMilestones[col.key])]
                }}</mat-icon>
              }
            </span>
            <span class="certificate-overview__er-cert-name">{{
              col.label
            }}</span>
          </div>
          <div class="certificate-overview__er-date">
            <mat-form-field
              appearance="outline"
              class="certificate-overview__er-date-field"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                [matDatepicker]="trainingPlannedPicker"
                [(ngModel)]="editMilestones[col.key].trainingPlanned"
                [placeholder]="
                  'certificateOverview.milestoneEditor.trainingPlanned'
                    | translate
                "
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="trainingPlannedPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #trainingPlannedPicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="certificate-overview__er-date">
            <mat-form-field
              appearance="outline"
              class="certificate-overview__er-date-field"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                [matDatepicker]="trainingDatePicker"
                [(ngModel)]="editMilestones[col.key].trainingDate"
                [placeholder]="
                  'certificateOverview.milestoneEditor.trainingDate' | translate
                "
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="trainingDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #trainingDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="certificate-overview__er-date">
            <mat-form-field
              appearance="outline"
              class="certificate-overview__er-date-field"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                [matDatepicker]="examDatePicker"
                [(ngModel)]="editMilestones[col.key].examDate"
                [placeholder]="
                  'certificateOverview.milestoneEditor.examDate' | translate
                "
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="examDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #examDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="certificate-overview__er-date">
            <mat-form-field
              appearance="outline"
              class="certificate-overview__er-date-field"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                [matDatepicker]="certifiedDatePicker"
                [(ngModel)]="editMilestones[col.key].certifiedDate"
                [placeholder]="
                  'certificateOverview.milestoneEditor.certifiedDate'
                    | translate
                "
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="certifiedDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #certifiedDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      }
    </div>

    <div class="certificate-overview__modal-foot">
      <span class="certificate-overview__modal-count"
        >{{ editActiveCertCount }}
        {{ 'certificateOverview.milestoneEditor.of' | translate }}
        {{ CERTIFICATE_COLUMNS.length }}
        {{
          'certificateOverview.milestoneEditor.certsActive' | translate
        }}</span
      >
      <div class="certificate-overview__modal-actions">
        <button
          class="certificate-overview__btn-text"
          type="button"
          (click)="editModalVisible = false"
        >
          {{ 'general.cancel' | translate }}
        </button>
        <button
          class="certificate-overview__btn-primary"
          type="button"
          [disabled]="savingMilestones"
          (click)="saveMilestones()"
        >
          @if (savingMilestones) {
            <mat-spinner diameter="16"></mat-spinner>
          } @else {
            {{ 'general.save' | translate }}
          }
        </button>
      </div>
    </div>
  </div>
}

<app-modal
  class="certificate-overview__template-picker-modal"
  [(visible)]="templatePickerVisible"
  [showButtons]="false"
  [showClose]="true"
  [contentTemplate]="templatePickerContent"
></app-modal>

<app-modal
  [(visible)]="deleteConfirmVisible"
  [showButtons]="true"
  [showClose]="true"
  [saveText]="'general.delete'"
  [contentTemplate]="deleteConfirmContent"
  (save)="executeDeleteTemplate()"
></app-modal>
<ng-template #deleteConfirmContent>
  <p>
    {{
      'certificateOverview.templatePicker.confirmDelete'
        | translate: { name: deleteConfirmName }
    }}
  </p>
</ng-template>

<ng-template #templatePickerContent>
  <div class="certificate-overview__template-picker">
    <div class="certificate-overview__picker-sub">
      {{ 'certificateOverview.templatePicker.modalSubtitle' | translate }}
    </div>
    <div class="certificate-overview__picker-title">
      {{ 'certificateOverview.templatePicker.title' | translate }}
    </div>

    <div class="certificate-overview__picker-presets">
      <span class="certificate-overview__picker-presets-label">{{
        'certificateOverview.templatePicker.startingPoint' | translate
      }}</span>
      @for (t of PREDEFINED_TEMPLATES; track t.id) {
        <button
          mat-stroked-button
          class="certificate-overview__picker-preset-chip"
          (click)="applyPresetToCustom(t.certs)"
        >
          {{ t.nameKey | translate }}
        </button>
      }
    </div>

    <div class="certificate-overview__picker-search-row">
      <mat-icon class="certificate-overview__picker-search-icon"
        >search</mat-icon
      >
      <input
        class="certificate-overview__picker-search-input"
        [placeholder]="
          'certificateOverview.templatePicker.searchCert' | translate
        "
        [(ngModel)]="certPickerSearchTerm"
      />
    </div>

    <div class="certificate-overview__picker-grid">
      @for (col of filteredCertColumnsForPicker; track col.key) {
        <div
          class="certificate-overview__picker-grid-item"
          [class.is-checked]="customCertKeys.includes(col.key)"
        >
          <mat-checkbox
            [checked]="customCertKeys.includes(col.key)"
            (change)="toggleCustomCert(col.key, $event.checked)"
          >
            {{ col.label }}
          </mat-checkbox>
        </div>
      }
    </div>

    <div class="certificate-overview__picker-footer">
      <span class="certificate-overview__picker-count">
        {{ customCertKeys.length }}
        {{ 'certificateOverview.templatePicker.of' | translate }}
        {{ CERTIFICATE_COLUMNS.length }}
        {{ 'certificateOverview.templatePicker.selected' | translate }}
      </span>
      @if (!showSaveNameInput) {
        <div class="certificate-overview__picker-actions">
          <button
            class="certificate-overview__btn-text"
            type="button"
            (click)="templatePickerVisible = false"
          >
            {{ 'general.cancel' | translate }}
          </button>
          <button
            class="certificate-overview__picker-save-btn"
            type="button"
            [disabled]="customCertKeys.length === 0"
            (click)="showSaveNameInput = true"
          >
            {{ 'certificateOverview.templatePicker.saveNew' | translate }}
          </button>
          <button
            class="certificate-overview__btn-primary"
            type="button"
            [disabled]="customCertKeys.length === 0"
            (click)="applyCustomTemplate()"
          >
            {{ 'general.apply' | translate }}
          </button>
        </div>
      } @else {
        <div
          class="certificate-overview__picker-actions certificate-overview__picker-actions--save"
        >
          <input
            class="certificate-overview__picker-name-input"
            [(ngModel)]="customTemplateName"
            [placeholder]="
              'certificateOverview.templatePicker.nameLabel' | translate
            "
            (keydown.enter)="saveCustomTemplate()"
          />
          <button
            class="certificate-overview__btn-text"
            type="button"
            (click)="showSaveNameInput = false; customTemplateName = ''"
          >
            {{ 'certificateOverview.templatePicker.back' | translate }}
          </button>
          <button
            class="certificate-overview__btn-primary"
            type="button"
            [disabled]="
              !customTemplateName.trim() ||
              customCertKeys.length === 0 ||
              savingTemplate
            "
            (click)="saveCustomTemplate()"
          >
            {{ 'general.save' | translate }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
